<template>
  <div>
    <SummaryTemplateList v-if="view === 'list'"
      @create="openCreate"
      @edit="openEdit"
      @clone="openClone"
    />
    <SummaryWizard v-else-if="view === 'wizard'"
      @close="view = 'list'"
      @saved="view = 'list'"
      @switch-to-builder="openBuilder"
    />
    <SummaryTemplateBuilder v-else
      :initialData="selectedTemplate"
      :isClone="isClone"
      @cancel="view = 'list'"
      @saved="view = 'list'"
    />
  </div>
</template>

<script setup lang="ts">
import SummaryTemplateList from './SummaryTemplateList.vue';
import SummaryTemplateBuilder from './SummaryTemplateBuilder.vue';
import SummaryWizard from './SummaryWizard.vue';

const view = ref<'list' | 'builder' | 'wizard'>('list');
const selectedTemplate = ref<Record<string, unknown> | null>(null);
const isClone = ref(false);

const openCreate = () => {
  selectedTemplate.value = null;
  isClone.value = false;
  view.value = 'wizard';
};

const openBuilder = () => {
  selectedTemplate.value = null;
  isClone.value = false;
  view.value = 'builder';
};

const openEdit = (template: Record<string, unknown>) => {
  selectedTemplate.value = template;
  isClone.value = false;
  view.value = 'builder';
};

const openClone = (template: Record<string, unknown>) => {
  selectedTemplate.value = template;
  isClone.value = true;
  view.value = 'builder';
};
</script>
